export default "__VITE_ASSET__CDJClS4w__"